module.exports = __webpack_public_path__ + "298018a63f4b92e93201276292cdc4ab.png";